import { Component, h, State, Prop } from '@stencil/core';
import { getReactions } from '../../api/message-reaction.js';
import { showToast } from '../../stories/Components/Toaster/toast-helper';
import '../../stories/Components/ReactionsContainer/ReactionsContainer.js';

@Component({
  tag: 'reaction-container',
  styleUrl: '',
  shadow: true,
})
export class ReactionContainer {
  @Prop() messageId: string;
  @State() reactionUsers: any[] = [];
  @Prop() userMetaData: any;
  @Prop() reactions: any[] = [];
  private conversationId: string;
  @State() selectedEmojiId: string;

  async componentWillLoad() {
    const urlParams = new URLSearchParams(window.location.search);
    this.conversationId = urlParams.get('conversation');

    if(this.reactions && this.reactions.length > 0) {
      const emojiId = this.reactions[0]?.emojiId;
      this.selectedEmojiId = emojiId;
      await this.handleReactionTabClick(emojiId);
    }
  }

  async handleReactionTabClick(emojiId: string) {
    try {
      const response = await getReactions(this.conversationId, this.messageId, emojiId);
      this.reactionUsers = response?.reactions || [];
    } catch (error) {
      showToast({
        message: 'Error while getting reaction',
        type: 'error',
        duration: 3000,
        position: 'bottom-left',
      });
    }
  }

  render() {
    return (
      <reactions-container
        onEmojiTabClick={e => this.handleReactionTabClick(e.detail)}
        reactionsUser={this.reactionUsers}
        userMetaData={this.userMetaData}
        reactions={this.reactions}
        bgColor="var(--bg-secondary-color)"
        borderRadius="10px"
        color="var(--text-primary-color)"
        fontSize="20px"
        messageId={this.messageId}
        selectedEmojiId={this.selectedEmojiId}
      ></reactions-container>
    );
  }
}
